import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

// @Injectable()
// export class KeycloakHttpInterceptor implements HttpInterceptor {
//   constructor(private keycloakService: KeycloakService) {}

  export const KeycloakHttpInterceptor: HttpInterceptorFn = (req, next) => {
    const keycloakService = inject(KeycloakService);
    return from(keycloakService.getToken()).pipe(
      switchMap(token => {
        if (token) {
          // Attach the token to request headers
          const authReq = req.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
          });
          return next(authReq);
        }
        return next(req);
      })
    );
  
}
